import React from 'react'

import { RegistrationListHeader } from './RegistrationListHeader'
import { RegistrationListItem } from './RegistrationListItem'

import type { TenantRegistration } from '../../../../types/registration'
import type { TenantRegistrationActions } from '../../../../types/registration/actions'
import { WARNING_ONLY_FIELDS } from '../constants'

export interface RegistrationListProps {
  registrations: TenantRegistration[]
  openRegistrationIDs: Set<string>
  areActionsHidden: boolean
  checkedIDs?: Set<string>
  onCheckedChange?: (id: string) => void
  onCheckedAllChange?: (checked: boolean) => void
  onItemClick: (id: string) => void
  onItemActionsClick: (id: string, action: TenantRegistrationActions) => void
}

export const RegistrationList: React.FC<RegistrationListProps> = (props) => {
  const showCheckboxes = props.checkedIDs !== undefined
  const importableCount = showCheckboxes
    ? props.registrations.filter((r) => (r.missingFields ?? []).filter((f) => !WARNING_ONLY_FIELDS.has(f)).length === 0).length
    : 0

  return (
    <>
      <div className="shadow bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 border-b rounded-lg">
        <div className="align-middle inline-block min-w-full">
          <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700 table-auto">
            <thead className="bg-slate-50 dark:bg-slate-800">
              <RegistrationListHeader
                areActionsHidden={props.areActionsHidden}
                showCheckbox={showCheckboxes}
                allChecked={showCheckboxes && props.checkedIDs!.size > 0 && props.checkedIDs!.size === importableCount}
                someChecked={showCheckboxes && props.checkedIDs!.size > 0 && props.checkedIDs!.size < importableCount}
                onCheckedAllChange={props.onCheckedAllChange}
              />
            </thead>
            <tbody className="bg-slate-50 dark:bg-slate-800 divide-y divide-slate-200 dark:divide-slate-700">
              {props.registrations?.map((registration: any) => (
                <RegistrationListItem
                  key={registration.id}
                  registration={registration}
                  isOpen={props.openRegistrationIDs.has(registration.id)}
                  areActionsHidden={props.areActionsHidden}
                  isChecked={showCheckboxes ? props.checkedIDs!.has(registration.id) : undefined}
                  onCheckedChange={props.onCheckedChange ? () => props.onCheckedChange!(registration.id) : undefined}
                  onClick={() => props.onItemClick(registration.id)}
                  onActionClick={(action) => props.onItemActionsClick(registration.id, action)}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default RegistrationList
